import {
	Grid,
	Row,
	Col,
	PanelContainer,
	PanelBody,
	Panel,
	Button,
	Form,
	Icon,
	InputGroup,
	FormGroup,
	FormControl,
	Alert,
	Fade,
} from '@sketchpixy/rubix';
import React from 'react';

import { Meteor } from 'meteor/meteor';

export default class LoginPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			status: 'UNKNOWN',
			login: null,
			password: null
		};

		if (Meteor.user()) {
			this.props.router.push('/app');
		}
	}

	login(e) {
		e.preventDefault();
		let elements = e.target.elements;

		this.setState({ status: 'LOADING' });
		Meteor.loginWithPassword(elements.login.value, elements.password.value, (error) => {
			if (error)
				return this.setState({ status: 'LOGIN_FAILED' });
			this.props.router.push('/app');
		});
	}

	render() {
		return (
			<div id='auth-container' className='login'>
				<div id='auth-row'>
					<div id='auth-cell'>
						<Grid>
							<Row>
								<Col sm={4} smOffset={4} xs={10} xsOffset={1} collapseLeft collapseRight>
									<PanelContainer controls={false}>
										<Panel>
											<PanelBody style={{padding: 0}}>
												<div className='text-center bg-darkblue fg-white'>
													<h3 style={{margin: 0, padding: 25}}>Connexion</h3>
												</div>
												<div>
													<div style={{padding: 25, paddingTop: 0, paddingBottom: 0, margin: 'auto', marginBottom: 25, marginTop: 25}}>
														<Form onSubmit={::this.login}>
															<FormGroup controlId='login'>
																<InputGroup bsSize='large'>
																	<InputGroup.Addon>
																		<Icon glyph='icon-fontello-user' />
																	</InputGroup.Addon>
																	<FormControl autoFocus type='text' className='border-focus-blue' placeholder='Login' ref='login' name="email" />
																</InputGroup>
															</FormGroup>
															<FormGroup controlId='password'>
																<InputGroup bsSize='large'>
																	<InputGroup.Addon>
																		<Icon glyph='icon-fontello-key' />
																	</InputGroup.Addon>
																	<FormControl type='password' className='border-focus-blue' placeholder='Mot de passe' ref='password' name="password"/>
																</InputGroup>
															</FormGroup>
															<Button outlined lg type='submit' bsStyle='blue' style={{margin: '16px auto', display: 'block', width: '100%'}}>
																{this.state.status == 'LOADING' ? (
																	<Icon glyph='glyphicon-refresh' className='glyphicon-spin' />
																) : (
																'Se connecter'
																)}
															</Button>
															<Fade in={this.state.status == 'LOGIN_FAILED'}>
																<Alert bsStyle="danger">
																	<strong>Mauvaise combinaison login/mot de passe.</strong>
																</Alert>
															</Fade>
														</Form>
													</div>
												</div>
											</PanelBody>
										</Panel>
									</PanelContainer>
								</Col>
							</Row>
						</Grid>
					</div>
				</div>
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./src/universal/components/auth/LoginPage.js
 **/